<template>
  <gh-menu :btn-text="title" :title="title" :allowSubmit="allowSubmit" @submit="submit">
    <template #title="{title}">
      <v-layout row wrap>
        <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
          append-icon="mdi-circle-edit-outline" @change="query">
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon @click="query()">
          <v-icon>mdi-database-refresh</v-icon>
        </v-btn>
      </v-layout>
    </template>
    <v-data-table v-model="value" :headers="headers" :items="items" hide-actions class="elevation-1" select-all
      :pagination.sync="args.pagination" item-key="Id" :loading="isBusy" :total-items="totals">
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td>
            <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
          </td>
          <td>{{ props.item.Cd }}</td>
          <td>{{ props.item.Name }}</td>
          <td>{{ props.item.Ctrl }}</td>
          <td>{{ props.item.PackingSpec }}</td>
          <td>{{ props.item.Developer }}</td>
        </tr>
      </template>
    </v-data-table>
  </gh-menu>
</template>

<style scoped>

</style>

<script>
  import MaterialSelector from "./materialSelector.ts";
  export default MaterialSelector;
</script>